import * as React from "react";
import { Create, SimpleForm, TextInput, SelectInput, required, useDataProvider } from "react-admin";
import { useClub } from "../club/ClubContext";


export function TeamCreate() {
  const dataProvider = useDataProvider();
  const [choices, setChoices] = React.useState<{ id: string; name: string }[]>([]);
  const [clubs, setClubs] = React.useState<{ id: string; display_name: string }[]>([]);
  const { clubId } = useClub();

  return (
    <Create>
      <SimpleForm defaultValues={{ club_id: clubId }}>
        <TextInput source="name" validate={[required()]} fullWidth />
        <TextInput source="club_id" sx={{ display: "none" }} />
      </SimpleForm>
    </Create>
  );
}
